import { useEffect } from "react";
import type { KbLane } from "@/lib/kb/types";
import type { GuidancePurpose } from "./trainingPanelGuidance";

/** When Training Ask pricing is quarantined for the session, clear any persisted pricing lane / purpose selections. */
export function useTrainingPricingAskReset(params: {
  authStatus: string;
  showPricingAsk: boolean;
  laneSelection: KbLane;
  setLaneSelection: (v: KbLane) => void;
  laneOverrideOnce: KbLane | null;
  setLaneOverrideOnce: (v: KbLane | null) => void;
  purposeSelection: GuidancePurpose | null;
  setPurposeSelection: (v: GuidancePurpose | null) => void;
}) {
  const {
    authStatus,
    showPricingAsk,
    laneSelection,
    setLaneSelection,
    laneOverrideOnce,
    setLaneOverrideOnce,
    purposeSelection,
    setPurposeSelection,
  } = params;

  useEffect(() => {
    if (authStatus !== "ready" || showPricingAsk) return;
    if (laneSelection === "pricing") setLaneSelection("answers");
    if (laneOverrideOnce === "pricing") setLaneOverrideOnce(null);
    if (purposeSelection === "pricing") setPurposeSelection(null);
  }, [
    authStatus,
    showPricingAsk,
    laneSelection,
    laneOverrideOnce,
    purposeSelection,
    setLaneSelection,
    setLaneOverrideOnce,
    setPurposeSelection,
  ]);
}
